import { createReducer, on } from '@ngrx/store';
import { UserType } from '../types/user.type';
import { authResetAction, authSetAuthInfo, authSetAuthenticated, authSetEmailHash, authSetLastAction, authSetOrgId, authSetOrgName, authSetUiAnalytics, authSetUserEmail, authSetUserName, authSetUserType } from './auth.actions';

export const AUTH_FEATURE_KEY = 'platform-auth';
export interface IAuthState {
    authenticated: boolean;
    userName: string | undefined;
    email: string | undefined;
    lastActionTime: number;
    uiAnalytics: boolean;
    orgId: string | undefined;
    orgName: string | undefined;
    emailHash: string | undefined;
    userType: UserType | undefined;
}

const authInitialState: IAuthState = {
    authenticated: false,
    userName: undefined,
    email: undefined,
    lastActionTime: Date.now(),
    uiAnalytics: false,
    orgId: undefined,
    orgName: undefined,
    emailHash: undefined,
    userType: undefined
};

export const authReducer = createReducer(
    authInitialState,
    // Reset the auth state back to initial state
    on(authResetAction, () => ({
        ...authInitialState
    })),
    // Sets authenticated status
    on(authSetAuthenticated, (state, { authenticated }) => ({
        ...state,
        authenticated
    })),
    // Sets user name
    on(authSetUserName, (state, { userName }) => ({
        ...state,
        userName
    })),
    on(authSetUserEmail, (state, { email }) => ({
        ...state,
        email
    })),
    on(authSetOrgId, (state, { orgId }) => ({
        ...state,
        orgId
    })),
    on(authSetOrgName, (state, { orgName }) => ({
        ...state,
        orgName
    })),
    on(authSetUiAnalytics, (state, { uiAnalytics }) => ({
        ...state,
        uiAnalytics
    })),
    on(authSetEmailHash, (state, { emailHash }) => ({
        ...state,
        emailHash
    })),
    on(authSetUserType, (state, { email }) => ({
        ...state,
        userType: (email.endsWith('@guideline.ai') || email.endsWith('@sqad.com') ? 'Internal' : 'External') as UserType
    })),
    // Sets the time of the users last action. Used in auto-logout
    on(authSetLastAction, (state, { lastActionTime }) => ({
        ...state,
        lastActionTime
    })),
    // Updates the entire auth object
    on(authSetAuthInfo, (state, { authInfo }) => ({
        ...state,
        authInfo
    }))
);
